export type RoleConfig = {
  label: string;
  color: string; // Ant Design tag color
  description: string;
};

const ROLE_CONFIG: Record<string, RoleConfig> = {
  ROLE_NEIGHBOUR: {
    label: 'Utilisateur',
    color: 'green',
    description: "Utilisateur de l'app mobile Roving",
  },
  ROLE_CUSTOMER: {
    label: 'Gestionnaire Pilotage',
    color: 'blue',
    description: "Gestionnaire d'un réseau via l'app Pilotage",
  },
  ROLE_ADMIN: {
    label: 'Admin Control',
    color: 'red',
    description: 'Administrateur du backoffice Control',
  },
  ROLE_SUPER_ADMIN: {
    label: 'Super Admin',
    color: 'magenta',
    description: "Super administrateur Ensembl'",
  },
  ROLE_INTERNAL: {
    label: "Interne Ensembl'",
    color: 'purple',
    description: "Compte interne Ensembl'",
  },
  ROLE_BOT: {
    label: 'Bot',
    color: 'default',
    description: 'Compte automatisé (bot)',
  },
  ROLE_UNKNOWN: {
    label: 'Inconnu',
    color: 'default',
    description: 'Rôle non identifié',
  },
};

// Rôles techniques masqués dans l'UI (bruit, présent partout)
const HIDDEN_ROLES = new Set(['ROLE_USER']);

export const ALL_ROLES_FOR_FILTER: { value: string; label: string }[] = [
  { value: 'ROLE_NEIGHBOUR', label: 'Utilisateur' },
  { value: 'ROLE_CUSTOMER', label: 'Gestionnaire Pilotage' },
  { value: 'ROLE_ADMIN', label: 'Admin Control' },
  { value: 'ROLE_SUPER_ADMIN', label: 'Super Admin' },
  { value: 'ROLE_INTERNAL', label: "Interne Ensembl'" },
];

export const getRoleConfig = (role: string): RoleConfig | null => {
  if (HIDDEN_ROLES.has(role)) return null;
  return (
    ROLE_CONFIG[role] ?? {
      label: role,
      color: 'default',
      description: 'Rôle non mappé',
    }
  );
};

export const visibleRoles = (
  roles: string[]
): { role: string; config: RoleConfig }[] => {
  return roles
    .map(role => ({ role, config: getRoleConfig(role) }))
    .filter(
      (x): x is { role: string; config: RoleConfig } => x.config !== null
    );
};
